import { render } from "./ZavbusServicePage.vue?vue&type=template&id=a6664cac&scoped=true"
import script from "./ZavbusServicePage.vue?vue&type=script&lang=ts"
export * from "./ZavbusServicePage.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-a6664cac"

export default script